<template>
    <transition name="modal">
        <div class="modal__mask" v-if="showModal">
            <div class="modal__wrapper">
                <div class="modal__container modal-posicao">
                    <div class="content__modal">
                        <button class="close__modal" @click="closeModal">
                            <i class="fas fa-times"></i>
                        </button>

                        <div class="inner__modal">
                            <h2>Posição PAS</h2>
                            <div class="conteudo-tabela">
                                <table class="table-modal">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Nome Produto</th>
                                            <th>Tipo</th>
                                            <th>Qtd Bloqueada</th>
                                            <th>Qtd Total</th>
                                            <th>Valor Bruto</th>
                                            <th>Valor IR</th>
                                            <th>Valor IOF</th>
                                            <th>Valor Líquido</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in listaPosicao" :key="item.IdProdutoPAS">
                                            <td>{{ item.IdProdutoPAS }}</td>
                                            <td>{{ item.NmProduto }}</td>
                                            <td>{{ item.Tipo }}</td>
                                            <td>{{ formatNumber(item.QtdBloqueada) }}</td>
                                            <td>{{ formatNumber(item.QtdTotal) }}</td>
                                            <td>{{ formatCurrency(item.ValorBruto) }}</td>
                                            <td>{{ formatCurrency(item.ValorIR) }}</td>
                                            <td>{{ formatCurrency(item.ValorIOF) }}</td>
                                            <td>{{ formatCurrency(item.ValorLiquido) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="button-row">
                                <button class="btnDefault" @click="closeModal">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters({
            showModal: "GET_MODAL_VISUALIZAR_POSICAO",
        }),
    },
    data() {
        return {
            listaPosicao: [
                {
                    IdProdutoPAS: 1001,
                    NmProduto: "Fundo de Investimento XYZ",
                    Tipo: "Fundo de Investimento",
                    QtdBloqueada: 100.50,
                    QtdTotal: 1500.75,
                    ValorBruto: 150000.00,
                    ValorIR: 2250.00,
                    ValorIOF: 150.00,
                    ValorLiquido: 147600.00
                },
                {
                    IdProdutoPAS: 1002,
                    NmProduto: "Fundo de Renda Fixa ABC",
                    Tipo: "Fundo de Renda Fixa",
                    QtdBloqueada: 0.00,
                    QtdTotal: 2500.00,
                    ValorBruto: 250000.00,
                    ValorIR: 3750.00,
                    ValorIOF: 250.00,
                    ValorLiquido: 246000.00
                },
                {
                    IdProdutoPAS: 1003,
                    NmProduto: "Fundo Multimercado DEF",
                    Tipo: "Fundo Multimercado",
                    QtdBloqueada: 50.25,
                    QtdTotal: 800.00,
                    ValorBruto: 80000.00,
                    ValorIR: 1200.00,
                    ValorIOF: 80.00,
                    ValorLiquido: 78720.00
                }
            ]
        }
    },
    methods: {
        closeModal() {
            this.$store.commit("SET_MODAL_VISUALIZAR_POSICAO", false);
        },
        formatCurrency(value) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value);
        },
        formatNumber(value) {
            return new Intl.NumberFormat('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(value);
        }
    },
};
</script>

<style lang="scss" scoped>
@include modal;

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.modal-posicao {
    width: 95% !important;
    max-width: 1200px !important;
    height: auto !important;
    max-height: 85vh !important;

    @media (max-width: 768px) {
        width: calc(100% - 20px) !important;
        max-width: calc(100% - 20px) !important;
        height: auto !important;
        max-height: 85vh !important;
        margin: 10px !important;
        border-radius: 16px !important;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3) !important;
    }
}

/* Mobile Styles */
@media (max-width: 768px) {
    .modal__mask {
        position: fixed !important;
        z-index: 9998 !important;
        top: 0 !important;
        left: 0 !important;
        width: 100% !important;
        height: 100% !important;
        background-color: rgba(0, 0, 0, 0.7) !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        padding: 10px !important;
    }
    
    .modal__wrapper {
        display: flex !important;
        flex-direction: column !important;
        justify-content: center !important;
        width: 100% !important;
        margin: 0 auto !important;
        height: 100% !important;
    }
}

.inner__modal {
    width: 100%;
    padding: 20px;

    @media (max-width: 768px) {
        padding: 10px;
    }

    h2 {
        margin-bottom: 20px;
        font-family: 'Inter', sans-serif;
        font-weight: 600;
        font-size: 24px;
        color: #101828;
        text-align: center;

        @media (max-width: 768px) {
            font-size: 20px;
            margin-bottom: 15px;
        }
    }
}

.conteudo-tabela {
    max-height: 60vh;
    overflow-y: auto;
    overflow-x: auto;
    margin-bottom: 20px;

    @media (max-width: 768px) {
        max-height: 55vh;
        margin-bottom: 15px;
    }
}

.content__modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: relative;

    .close__modal {
        position: absolute;
        right: 20px;
        top: 20px;
        font-family: "Montserrat";
        background: transparent;
        border: none;
        font-size: 20px;
        cursor: pointer;
        color: #667085;
        z-index: 10;

        @media (max-width: 768px) {
            top: 10px;
            right: 10px;
            font-size: 18px;
        }

        &:hover {
            color: #344054;
        }
    }
}

.button-row {
    display: flex;
    justify-content: center;
    gap: 10px;
    width: 100%;
    padding-top: 10px;

    .btnDefault {
        height: 40px;
        font-family: 'Inter', sans-serif;
        background-color: white;
        color: #344054;
        border: 1px solid #D0D5DD;
        border-radius: 8px;
        cursor: pointer;
        padding: 0 24px;
        font-weight: 600;
        font-size: 14px;

        &:hover {
            background-color: #F9FAFB;
        }
    }
}

.table-modal {
    width: 100%;
    border-collapse: collapse;
    font-family: 'Inter', sans-serif;

    thead {
        background-color: #F9FAFB;
        
        th {
            text-align: left;
            padding: 12px 16px;
            color: #667085;
            font-size: 12px;
            font-weight: 500;
            line-height: 18px;
            border-bottom: 1px solid #EAECF0;
            white-space: nowrap;

            @media (max-width: 768px) {
                padding: 8px 10px;
                font-size: 11px;
            }
        }
    }

    tbody {
        tr {
            border-bottom: 1px solid #EAECF0;

            &:hover {
                background-color: #F9FAFB;
            }

            td {
                padding: 12px 16px;
                color: #667085;
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                white-space: nowrap;

                @media (max-width: 768px) {
                    padding: 8px 10px;
                    font-size: 12px;
                }
            }
        }
    }
}
</style>